import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/help")({
  component: HelpRoute,
});

function HelpRoute() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Help Center</h1>
      <p className="text-muted-foreground">Help documentation coming soon...</p>
    </div>
  );
}
